import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
  Divider,
  Chip,
  CircularProgress,
  TextField,
  Button
} from '@mui/material';
import axios from 'axios';

const PaymentDashboard = ({ paymentMovements = [] }) => {
  const [movimientos, setMovimientos] = useState(paymentMovements);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);

//   const fetchMovimientos = async () => {
//     setLoading(true);
//     try {
//       const desde = dateRange[0]?.toISOString();
//       const hasta = dateRange[1]?.toISOString();
//       const response = await axios.get('/api/movimientos', {
//         params: { desde, hasta },
//       });
//       setMovimientos(response.data);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchMovimientos();
//   }, []);

    const amount = (mov) => {
        return mov.NetCreditAmount > 0 && mov.NetDebitAmount === 0 ? mov.NetCreditAmount : mov.NetDebitAmount > 0 && mov.NetCreditAmount === 0 ? mov.NetDebitAmount : 0;
    }

  return (
    <Box p={3}>
        <List>
            {movimientos && movimientos.map((mov, index) => (
            <React.Fragment key={index}>
                <ListItem alignItems='flex-start'>
                <Paper variant='outlined' sx={{ width: '100%', padding: 2 }}>
                    <Box display='flex' justifyContent='space-between' alignItems='center' mb={1}>
                    <Typography variant='subtitle2'>{new Date(mov.Date).toLocaleString()}</Typography>
                    <Chip
                        label={mov.PaymentMethod}
                        size='small'
                        color={mov.NetCreditAmount > 0 && mov.NetDebitAmount === 0 ? 'success' : mov.NetDebitAmount > 0 && mov.NetCreditAmount === 0 ? 'error' : null}
                    />
                    </Box>

                    <Typography variant='body1' fontWeight='bold' color={mov.NetCreditAmount > 0 && mov.NetDebitAmount === 0 ? 'green' : mov.NetDebitAmount > 0 && mov.NetCreditAmount === 0 ? 'red' : null}>
                    {mov.NetCreditAmount > 0 && mov.NetDebitAmount === 0 ? '+' : mov.NetDebitAmount > 0 && mov.NetCreditAmount === 0 ? '-' : ''}${amount(mov).toLocaleString()}
                    </Typography>

                    <Typography variant='body2' color='text.secondary'>
                    Método: {mov.PaymentMethod || '-'} — Balance: ${mov.BalanceAmount.toLocaleString()}
                    </Typography>
                </Paper>
                </ListItem>
                <Divider />
            </React.Fragment>
            ))}
        </List>
    </Box>
  );
};

export default PaymentDashboard;
